module.exports = "/packs/015-7a0449be02a2d3ccd86ed870e31c18de.jpg";